"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToEndOfDay = exports.transformToStartOfDay = exports.dateToNextMs = exports.epochMsToFullDateStr = exports.epochMsToDateTime = exports.dateTimeToEpoch = exports.dateToEpoch = exports.isReportingDateValidForCashBalanceRefresh = exports.setCloseOfBusiness5pmEst = exports.offsetFromDateTime = exports.isWithinLastNBusinessDaysOfMonth = exports.isLastDayOfQuarter = exports.isFirstDayOfQuarter = exports.getDaysInQuarter = exports.getDaysInMonth = exports.diffBusinessDays = exports.addBusinessDays = exports.createDateTime = exports.currentEpochSeconds = exports.currentEpochMs = exports.currentDateTime = exports.currentDateStr = exports.currentBusinessDay = exports.isBusinessDay = exports.isHoliday = exports.isWeekend = exports.MXBankHolidays = exports.GoodFriday = exports.GoodThursday = exports.DiaDeLaVirgenDeGuadalupe = exports.DiaDeLaRevolucion = exports.DiaDeLosFielesDifuntos = exports.DiaDeLaIndependencia = exports.DiaDelTrabajo = exports.CumpleanosDeBenitoJuarez = exports.DiaDeLaConstitucion = exports.USFederalHolidays = exports.ChristmasDay = exports.ThanksgivingDay = exports.VeteransDay = exports.ColumbusDay = exports.LaborDay = exports.ForthOfJuly = exports.Juneteenth = exports.MemorialDay = exports.PresidentsDay = exports.MLKJrDay = exports.NewYearDay = void 0;
const _ = __importStar(require("lodash"));
const luxon_1 = require("luxon");
const finley_types_1 = require("@finley-technologies/finley-types");
const consts = __importStar(require("../consts"));
const error_1 = require("../error");
const typeguards = __importStar(require("../typeguards"));
const consts_1 = require("./consts");
/*
 * Internal helper methods
 */
// The official rules for observance are pretty simple:
//    If the holiday lands on a Saturday, observance is on the previous Friday.
//    If the holiday lands on a Sunday, observance is on the following Monday.
const observedDate = (holiday) => {
    if (holiday.weekday < 6)
        return holiday;
    if (holiday.weekday === 6)
        return holiday.minus({ days: 1 });
    return holiday.plus({ days: 1 });
};
const nthWeekdayInMonth = (nth, weekOfDay, month, year) => {
    (0, error_1.finleyAssert)(nth > 0, 'nth week must be greater than 1');
    const ret = luxon_1.DateTime.local(year, month, 1);
    let offset;
    // Find first target weekOfDay, ie) first Monday, first Thursday, etc...
    if (ret.weekday > weekOfDay) {
        offset = 7 + weekOfDay - ret.weekday;
    }
    else {
        offset = weekOfDay - ret.weekday;
    }
    // Since first target weekOfDay is found, we need to subtract 1 from n-th target
    offset += 7 * (nth - 1);
    return ret.plus({ days: offset });
};
/**
 * Generally speaking, we should keep visibility of these commonly defined HolidayFunction to be private within this module, and exposing them by packing them into
 * a set of HolidayFunctions like `USFederalHolidays`.
 */
// New year day => January 1st
const NewYearDay = (year) => luxon_1.DateTime.local(year, 1, 1);
exports.NewYearDay = NewYearDay;
// MLK => Third Monday in January
const MLKJrDay = (year) => nthWeekdayInMonth(3, 1, 1, year);
exports.MLKJrDay = MLKJrDay;
// Presidents day => Third Monday in February
const PresidentsDay = (year) => nthWeekdayInMonth(3, 1, 2, year);
exports.PresidentsDay = PresidentsDay;
// Memorial day => Last Monday in May
const MemorialDay = (year) => {
    const ret = luxon_1.DateTime.local(year, 5, 31);
    return ret.weekday > 1 ? ret.minus({ days: ret.weekday - 1 }) : ret;
};
exports.MemorialDay = MemorialDay;
// Juneteenth => June 19th
const Juneteenth = (year) => luxon_1.DateTime.local(year, 6, 19);
exports.Juneteenth = Juneteenth;
// Independence day => July 4th
const ForthOfJuly = (year) => luxon_1.DateTime.local(year, 7, 4);
exports.ForthOfJuly = ForthOfJuly;
// Labor day => First Monday in September
const LaborDay = (year) => nthWeekdayInMonth(1, 1, 9, year);
exports.LaborDay = LaborDay;
// Columbus day => Second Monday in October
const ColumbusDay = (year) => nthWeekdayInMonth(2, 1, 10, year);
exports.ColumbusDay = ColumbusDay;
// Veteran's day => November 11th
const VeteransDay = (year) => luxon_1.DateTime.local(year, 11, 11);
exports.VeteransDay = VeteransDay;
// Thanksgiving day => Fourth Thursday in November
const ThanksgivingDay = (year) => nthWeekdayInMonth(4, 4, 11, year);
exports.ThanksgivingDay = ThanksgivingDay;
// export const ChristmasEve = (year: number) => DateTime.local(year, 12, 24);
// Christmas day => December 25th
const ChristmasDay = (year) => luxon_1.DateTime.local(year, 12, 25);
exports.ChristmasDay = ChristmasDay;
// export const NewYearEve = (year: number) => DateTime.local(year, 12, 31);
exports.USFederalHolidays = [
    exports.NewYearDay,
    exports.MLKJrDay,
    exports.PresidentsDay,
    exports.MemorialDay,
    exports.Juneteenth,
    exports.ForthOfJuly,
    exports.LaborDay,
    exports.ColumbusDay,
    exports.VeteransDay,
    exports.ThanksgivingDay,
    exports.ChristmasDay,
];
/**
 * At time of writing, 2023-05-15 (ask @sachinr4 if needed)
 * Used to support interest rate holidays for MX bank rates:
 *  - TIIE28
 *
 * Source: https://www.banxico.org.mx/financial-system/d/%7B78042524-F8E9-89EB-9A8E-FD40D0CBCF40%7D.pdf
 * Notable missing element at time of writing is December 1st, which is only celebrated every 6 years
 * TODO: @sachinr4 - review again in 2024 to see updated bank schedule prior to updating list
 *
 * MX bank also observes weekends (Saturday/Sunday) as bank holidays
 * No special logic required to support this with existing common date functions
 *
 * Good Thursday and Good Friday are determined relative to Easter,
 *    which is determined by the full Moon that occurs on/after the spring equinox.
 * Moon cycle logic is not being encoded into the base date package logic at this time.
 * Historical easter dates are provided as a list and processed as a function based on the year.
 */
// Dia de la Constitucion => First Monday in February
const DiaDeLaConstitucion = (year) => nthWeekdayInMonth(1, 1, 2, year);
exports.DiaDeLaConstitucion = DiaDeLaConstitucion;
// Cumpleaños de Benito Juarez => Third Monday in March
const CumpleanosDeBenitoJuarez = (year) => nthWeekdayInMonth(3, 1, 3, year);
exports.CumpleanosDeBenitoJuarez = CumpleanosDeBenitoJuarez;
// Dia del Trabajo => May 1st
const DiaDelTrabajo = (year) => luxon_1.DateTime.local(year, 5, 1);
exports.DiaDelTrabajo = DiaDelTrabajo;
// Dia de la Independencia => September 16th
const DiaDeLaIndependencia = (year) => luxon_1.DateTime.local(year, 9, 16);
exports.DiaDeLaIndependencia = DiaDeLaIndependencia;
// Dia de los Fieles Difuntos => November 2nd
const DiaDeLosFielesDifuntos = (year) => luxon_1.DateTime.local(year, 11, 2);
exports.DiaDeLosFielesDifuntos = DiaDeLosFielesDifuntos;
// Dia de la Revolucion => Third Monday in November
const DiaDeLaRevolucion = (year) => nthWeekdayInMonth(3, 1, 11, year);
exports.DiaDeLaRevolucion = DiaDeLaRevolucion;
// Día de la Virgen de Guadalupe => December 12th
const DiaDeLaVirgenDeGuadalupe = (year) => luxon_1.DateTime.local(year, 12, 12);
exports.DiaDeLaVirgenDeGuadalupe = DiaDeLaVirgenDeGuadalupe;
// Rates only captured as of 2023 onwards, but backfilling a couple of years
// Sourced from US census data (or Wikipedia, use Gregorian Easter):
// https://www.census.gov/data/software/x13as/genhol/easter-dates.html
const EasterDateMap = {
    2021: { month: 4, day: 4 },
    2022: { month: 4, day: 17 },
    2023: { month: 4, day: 9 },
};
// Easter always falls on a Sunday
// Luxon datetime Sunday is end of the current week
// Apply weekday to current week
const getWeekdayPriorToEaster = (year, weekday) => {
    const { month: easterMonth, day: easterDay } = EasterDateMap[year];
    const easterDate = luxon_1.DateTime.local(year, easterMonth, easterDay);
    return easterDate.set({ weekday });
};
// Good Thursday => Thursday prior to Easter
const GoodThursday = (year) => {
    return getWeekdayPriorToEaster(year, 4);
};
exports.GoodThursday = GoodThursday;
// Good Friday => Friday prior to Easter
const GoodFriday = (year) => {
    return getWeekdayPriorToEaster(year, 5);
};
exports.GoodFriday = GoodFriday;
// By default, when using this set: observed = false
exports.MXBankHolidays = [
    exports.NewYearDay, // Año Nuevo (New Year’s Day)
    exports.DiaDeLaConstitucion,
    exports.CumpleanosDeBenitoJuarez,
    exports.GoodThursday,
    exports.GoodFriday,
    exports.DiaDelTrabajo,
    exports.DiaDeLaIndependencia,
    exports.DiaDeLosFielesDifuntos,
    exports.DiaDeLaRevolucion,
    exports.DiaDeLaVirgenDeGuadalupe,
    exports.ChristmasDay,
];
const isWeekend = (val) => val.weekday > 5;
exports.isWeekend = isWeekend;
// NOTE: isHoliday method can definitely be improved by some memoization
const isHoliday = (val, holidays, observed = true) => {
    // very very special edge-case:
    // There's an even more special edge-case, where the holidays func does not include
    // NewYearDay, this block will still check for observed New Year's date.  Handling
    // such case is very hard at this time, so I will punt this very specialized edge-case.
    if (observed && val.month === 12 && val.day === 31) {
        return observedDate((0, exports.NewYearDay)(val.year + 1))
            .startOf('day')
            .equals(val.startOf('day'));
    }
    return _.reduce(holidays, (found, holidayFn) => {
        if (found)
            return true;
        const holidayDate = observed
            ? observedDate(holidayFn(val.year))
            : holidayFn(val.year);
        return holidayDate.startOf('day').equals(val.startOf('day'));
    }, false);
};
exports.isHoliday = isHoliday;
/**
 * Returns true if the datetime is a business day
 */
const isBusinessDay = (val, holidays) => {
    return !(0, exports.isWeekend)(val) && !(0, exports.isHoliday)(val, holidays);
};
exports.isBusinessDay = isBusinessDay;
/**
 * Returns current Business day given a Datetime
 * This function exists to make sure that weekend will return appropriate Business day.
 * For example, Sat -> Fri, Sun -> Fri and we also need to account for holidays/observed holidays
 */
const currentBusinessDay = (val, holidays = exports.USFederalHolidays, convention = 'preceding') => {
    let ret = val;
    /* eslint-disable no-restricted-syntax */
    while (!(0, exports.isBusinessDay)(ret, holidays)) {
        ret = ret.plus({ days: convention === 'preceding' ? -1 : 1 });
    }
    /* eslint-enabled no-restricted-syntax */
    return ret;
};
exports.currentBusinessDay = currentBusinessDay;
/**
 * Returns current Util.FullDateStr as of EST
 */
const currentDateStr = (tz = finley_types_1.Util.DateTimeZones['America/New_York']) => {
    return luxon_1.DateTime.now().setZone(tz).toISODate();
};
exports.currentDateStr = currentDateStr;
/**
 * Returns current DateTime as of EST
 */
const currentDateTime = () => {
    return luxon_1.DateTime.now().setZone('America/New_York');
};
exports.currentDateTime = currentDateTime;
const currentEpochMs = () => {
    return luxon_1.DateTime.now().toMillis();
};
exports.currentEpochMs = currentEpochMs;
const currentEpochSeconds = () => {
    return _.floor(luxon_1.DateTime.now().toSeconds());
};
exports.currentEpochSeconds = currentEpochSeconds;
const createDateTime = ({ month, day, year, hour, minute, second, millisecond, }) => {
    return luxon_1.DateTime.fromObject({
        zone: 'America/New_York',
    }).set(_.omitBy({
        month,
        day,
        year,
        hour,
        minute,
        second,
        millisecond,
    }, _.isNil));
};
exports.createDateTime = createDateTime;
/**
 * luxon helper methods add business-days using luxon DateTime
 *
 * How business day arithmetic should operate:
 * - Add: from current calendar date, add days 1 at a time while counting the number of visited business days
 * - Zero: do nothing, even if not a business day (if the user wants a business day, call a date rolling function for nearest preceding or following business day)
 * - Subtract: from current calendar date, subtract days 1 at a time while counting the number of visited business days
 *
 * When adding/subtracting days while starting on a non-business day, the starting point should not be adjusted.
 */
const addBusinessDays = (val, numBusinessDays, options) => {
    // Set defaults for options parameters
    const holidays = options?.holidays ?? exports.USFederalHolidays;
    const observed = options?.observed ?? true;
    const rollBeforeOperation = typeof options?.rollBeforeOperation !== 'undefined'
        ? options.rollBeforeOperation
        : 'preceding'; // DO NOT CHANGE WITHOUT REVIEWING EVERY USE OF addBusinessDays
    // Get current Business day.
    let retDateTime = rollBeforeOperation
        ? (0, exports.currentBusinessDay)(val, holidays, rollBeforeOperation)
        : val;
    if (numBusinessDays === 0)
        return retDateTime;
    const direction = numBusinessDays > 0 ? 1 : -1;
    let counter = Math.abs(numBusinessDays);
    // eslint-disable-next-line
    while (counter) {
        retDateTime = retDateTime.plus({ days: direction });
        // We only count, if it's not weekend and holiday
        if (!(0, exports.isWeekend)(retDateTime) &&
            !(0, exports.isHoliday)(retDateTime, holidays, observed)) {
            counter -= 1;
        }
    }
    return retDateTime;
};
exports.addBusinessDays = addBusinessDays;
/**
 * Internal helper method to calculate 'diff' in business-days
 * @param: a, comparison target
 * @param: b, comparison base
 * @param: holidays, list of holiday functions
 * @param: when holiday function is included, this flag indicates if we should use observed holiday.
 * IMPORTANT: sign really signifies the direction,
 *
 * The implementation output basically mimics python numpy.busday_count() output. For reference:
 *
 * Counts the number of valid days between begindates and enddates, not including the day of enddates.
 * If enddates specifies a date value that is earlier than the corresponding begindates date value, the count will be negative.
 * https://numpy.org/doc/stable/reference/generated/numpy.busday_count.html
 */
const diffBusinessDays = (a, b, holidays = exports.USFederalHolidays, observed = true) => {
    let diffDays = a.diff(b, ['days']).days;
    // direction of cacluation is important now for businessDay diff calc
    const isPositive = diffDays >= 0;
    const startDate = isPositive ? b : a;
    const endDate = isPositive ? a : b;
    // Let's take care of edge weekends and interior weekends.
    diffDays = Math.abs(diffDays);
    diffDays -= startDate.weekday < 6 ? 0 : 8 - startDate.weekday; // sub starting weekend
    diffDays -= endDate.weekday < 6 ? 0 : endDate.weekday - 6; // sub ending weekend, don't include ending date
    if (diffDays < 7 &&
        startDate.weekday < 6 &&
        endDate.weekday < 6 &&
        endDate.weekday < startDate.weekday) {
        // NOTE: this is a bit complicated bit, so let me explain.  When diffDays are under 7 days when we take care
        // edge weekends, we still may have one interior weekend. This is calculated, can be detected by weekday wraps around
        // aka (startDate.weekday is larger). BUT, if one of the edges fall on a weekend, then we don't this won't hold true
        // or more accurately, there should not be an another weekend within less than 7 days from such date in either direction.
        diffDays -= 2;
    }
    diffDays -= Math.floor(diffDays / 7) * 2; // interior weekends
    // Now let's check if there's any specified holidays
    // We need to account for multiple years, just in case
    const years = _.range(startDate.year, endDate.year + 1); // the order (asc/desc) is irrelevant here
    _.forEach(holidays, (holiday) => {
        // For every holiday of each year
        _.forEach(years, (year) => {
            const holidayDate = observed
                ? observedDate(holiday(year))
                : holiday(year);
            // We need to check if the day is in between {a,b}
            if (startDate < holidayDate && holidayDate <= endDate) {
                diffDays -= (0, exports.isWeekend)(holidayDate) ? 0 : 1;
            }
        });
    });
    return isPositive ? diffDays : -diffDays;
};
exports.diffBusinessDays = diffBusinessDays;
/**
 * Get the number of days in the month given a respective date
 * @param date the input date
 * @returns the number of days in the month
 */
const getDaysInMonth = (date) => {
    if (date) {
        return date.daysInMonth;
    }
    throw Error('Invalid DateTime. Unable to get days in month');
};
exports.getDaysInMonth = getDaysInMonth;
/**
 * Get the number of days in the quarter given a respective date
 * @param date the target date
 * @returns the number of days in the quarter
 */
const getDaysInQuarter = (date) => {
    const { quarter } = date;
    if (quarter === 1) {
        return date.isInLeapYear ? 91 : 90;
    }
    if (quarter === 2) {
        return 91;
    }
    if (quarter === 3) {
        return 92;
    }
    if (quarter === 4) {
        return 92;
    }
    throw Error('Unable to determine quarter');
};
exports.getDaysInQuarter = getDaysInQuarter;
/**
 * Returns true if the provided date is the first day of the quarter, otherwise returns false
 */
const isFirstDayOfQuarter = (date) => {
    return date.startOf('quarter').toISODate() === date.toISODate();
};
exports.isFirstDayOfQuarter = isFirstDayOfQuarter;
/**
 * Returns true if the provided date is the last day of the quarter, otherwise returns false
 */
const isLastDayOfQuarter = (date) => {
    return date.endOf('quarter').toISODate() === date.toISODate();
};
exports.isLastDayOfQuarter = isLastDayOfQuarter;
/**
 * Returns true if provided date is within last N business days of the month associated with the date
 */
const isWithinLastNBusinessDaysOfMonth = (targetDate, numberOfDays) => {
    targetDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const lastDayOfMonth = (0, exports.createDateTime)({
        year: targetDate.year,
        month: targetDate.month,
        day: targetDate.daysInMonth,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
    });
    const lastBusinessDayOfMonth = (0, exports.currentBusinessDay)(lastDayOfMonth);
    // Starting on the last business day of month, subtract day limit minus one (exclude last day which is also a business day)
    const effectiveDate = (0, exports.addBusinessDays)(lastBusinessDayOfMonth, -1 * (numberOfDays - 1));
    if (targetDate >= effectiveDate && targetDate <= lastBusinessDayOfMonth)
        return true;
    return false;
};
exports.isWithinLastNBusinessDaysOfMonth = isWithinLastNBusinessDaysOfMonth;
// @jendevelops deliverablesV2-deprecated
/**
 * Calculates new DateTime date from offset from startDate according to offsetConfig
 */
const offsetFromDateTime = (startDate, offsetConfig) => {
    const { amount: configOffsetAmount, type: configOffsetType } = offsetConfig;
    const offsetFnByType = {
        businessDay: (value) => {
            return (0, exports.addBusinessDays)(startDate, value);
        },
        calendarDay: (value) => {
            return startDate.plus({ days: value });
        },
    };
    const offsetFn = offsetFnByType[configOffsetType];
    (0, error_1.finleyAssert)(offsetFn, 'Offset calculation function should exist for offset type');
    return offsetFn(configOffsetAmount);
};
exports.offsetFromDateTime = offsetFromDateTime;
// Note: this would benefit from operator overloading
const setCloseOfBusiness5pmEst = (date) => {
    if (typeguards.isFullDateStr(date)) {
        return luxon_1.DateTime.fromISO(date)
            .setZone('America/New_York')
            .set({ hour: consts.closeOfBusinessHour, minute: 0, second: 0 });
    }
    return date
        .setZone('America/New_York')
        .set({ hour: consts.closeOfBusinessHour, minute: 0, second: 0 });
};
exports.setCloseOfBusiness5pmEst = setCloseOfBusiness5pmEst;
const isReportingDateValidForCashBalanceRefresh = (reportingDate) => {
    // Get currentDateTime in Est
    const currentTime = (0, exports.currentDateTime)();
    const currentDate = (0, exports.currentDateStr)();
    const closeOfBusinessHoursCurrentDate = currentTime.hour >= consts.closeOfBusinessHour
        ? currentTime.plus({ days: 1 })
        : currentTime;
    const closeOfBusinessHoursCurrentDateStr = closeOfBusinessHoursCurrentDate.toISODate();
    // if it is after 5pm EST, you can upload a report for the next business day
    if (reportingDate !== closeOfBusinessHoursCurrentDateStr &&
        reportingDate !== currentDate) {
        return false;
    }
    return true;
};
exports.isReportingDateValidForCashBalanceRefresh = isReportingDateValidForCashBalanceRefresh;
/**
 * converts JSDate to epoch
 */
const dateToEpoch = (date) => {
    return luxon_1.DateTime.fromJSDate(date).toMillis();
};
exports.dateToEpoch = dateToEpoch;
const dateTimeToEpoch = (dateTime) => {
    return dateTime.toMillis();
};
exports.dateTimeToEpoch = dateTimeToEpoch;
const epochMsToDateTime = (epoch, zone = 'America/New_York') => {
    return luxon_1.DateTime.fromMillis(epoch, { zone });
};
exports.epochMsToDateTime = epochMsToDateTime;
const epochMsToFullDateStr = (epoch, zone = 'America/New_York') => {
    return luxon_1.DateTime.fromMillis(epoch, { zone }).toFormat(consts_1.formatFullDateStr);
};
exports.epochMsToFullDateStr = epochMsToFullDateStr;
/**
 * +1 millisecond to a date timestamp
 *
 * Used mainly for pagination.
 * NOTE: PG timestamp field stores record at microsecond precision
 * whereas node's Date has precision of millisecond.
 * this causes a timestamp truncation, and we will end up finding this record again
 * when we query for ('created_at', '>', afterTimeStamp);
 * to workaround this issue increment this timestamp by a millisecond.
 */
const dateToNextMs = (date) => {
    date.setMilliseconds(date.getMilliseconds() + 1);
    return date;
};
exports.dateToNextMs = dateToNextMs;
/**
 * converts given JSDate to start of the day.
 * @param {Date} date
 * @returns {Date}
 */
const transformToStartOfDay = (date) => {
    date.setHours(0, 0, 0, 0);
    return date;
};
exports.transformToStartOfDay = transformToStartOfDay;
/**
 * converts given JSDate to end of the day.
 * @param {Date} date
 * @returns {Date}
 */
const transformToEndOfDay = (date) => {
    date.setHours(23, 59, 59, 999);
    return date;
};
exports.transformToEndOfDay = transformToEndOfDay;
// All functions are exported above as individual named exports for ESM compatibility
//# sourceMappingURL=datetime.js.map